export interface Subscription {
    id: string;
    companyId: string;
    planId: string;
    addonIds: string[];
    seatConfigurationId: string;
    currency: string;
    seats: number;
    cycleDay: number;
    recurrencePaymentMethod: RecurrencePaymentMethod;
}

export enum RecurrencePaymentMethod {
    STRIPE = 'STRIPE',
    BILL_PAYMENT = 'BILL_PAYMENT',
    NO_RECURRENCE = 'NO_RECURRENCE'
}
